<template>
	<div>
		<div class="answer-block">
			<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">Can I cancel sale?</h1>
			<ul class="h-ul-gap">

				<li>
					If you have not yet confirmed, you can go into the order and click cancel <br><br>
					<div class="centered">
						<img src="/img/help/can_cancel_sale_1.png" alt="" width="600">
					</div>
					<div class="centered">
						<img src="/img/help/can_cancel_sale_2.png" alt="" width="600">
					</div>
					<a class="help-link" href="/account/new_sales.php">Go to Book Sales</a>
				</li>

				<li>
					If you have confirmed in error, you must issue a refund. You can do so by going to the order in your sales screen and clicking on refund <br><br>
					<div class="centered">
						<img src="/img/help/can_cancel_sale_3.png" alt="" width="600">
					</div>
					<a class="help-link" href="/account/new_sales.php">Go to Book Sales</a>
				</li>
			</ul>
		</div>

		<base-nav-links></base-nav-links>
	</div>
</template>

<script>
	import BaseNavLinks from './../components/BaseNavLinks';

	export default {
		name: "CanCancelSale",

		components: {
			BaseNavLinks,
		},
	}
</script>

<style scoped>
	.centered {
		text-align: center;
	}
</style>